import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../Modal';
import './SubscribeModal.css';
import HubspotForm from '../HubspotForm';

const SubscribeModal = ({ formId = '98d67b2a-a64e-4e4c-a02d-d4898de34694', onClickOutside }) => {
  return (
    <Modal className="SubscribeModal" onClickOutside={onClickOutside}>
      <div className="modal-body">
        <div className="content">
          <HubspotForm formId={formId} />
        </div>
      </div>
    </Modal>
  );
};

SubscribeModal.propTypes = {
  formId: PropTypes.string,
  onClickOutside: PropTypes.func,
};

export default SubscribeModal;
